import React from "react";
import { Box } from "@mui/material";

import { Header, Widget } from "../../../components/clinical/components";
import { useUserData } from "components/customHooks/userDataContext";
import { getCareOpportunitySummary } from "apiHandler/actions/clinical";
import { useEffect, useState } from "react";

const visitData = [
  { text: "19 visits completed", color: "#00695f" },
  { text: "1 visit ready to complete", color: "#009688" },
  { text: "2 upcoming appointments", color: "#4dd0e1" },
  { text: "18 visits to be scheduled", color: "#b2ebf2" },
];

const Dashboard = () => {
  const userData = useUserData();
  const token = userData?.access_token;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const payload = {
        type: "CareOpportunity",
        practice_id: userData?.selected_practice,
      };
      const res = await getCareOpportunitySummary(payload, token);
      if (res && res.length > 0) {
        console.log("res>>>>>>: ", res);
        setData(res);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const placeholders = Array(3).fill({});
  return (
    <Box>
      <Header visitData={visitData} />
      {(loading ? placeholders : data).map((item, index) => (
        <Widget
          key={index}
          title={item.care_oppt_category || ""}
          status={item.status || ""}
          paitents={item.count || 0}
          source={item.ext_source_name || ""}
          data={data}
          isLoading={loading}
        />
      ))}
    </Box>
  );
};

export default Dashboard;
